import { render } from "./FileMediaComponent.vue?vue&type=template&id=3fa88f2a"
import script from "./FileMediaComponent.vue?vue&type=script&lang=js"
export * from "./FileMediaComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__